module.exports = __webpack_public_path__ + "static/media/locationYellow.a8a1f93d.svg";